import memoize from 'lodash/memoize';
import { track } from '../../vendor/splitmetrics-track';



export const EVENT_NAME = 'in_app_click';


export default memoize((index = 0) => {
  const props = { in_app_index: Number(index), in_app_id: index };

  track(EVENT_NAME, props, { once: true, important: true, force: true });
}, (...args) => args.join(','));



// WEBPACK FOOTER //
// ./src/lib/track-event/in-app-click.js